// extracted by mini-css-extract-plugin
module.exports = {"btnOutline":"outlineButton_btnOutline__S_1gR"};